import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link, ReferenceOneField, TextField } from 'react-admin';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
    },
    avatar: {
        marginRight: theme.spacing(1),
    },
}));


const TIdLinkField = ({ record, size }) => {
    const classes = useStyles();
    return record ? (
        <div className={classes.root}>
            <Link to={`/orders/${record.id}/show/`} >{record.transaction_id}</Link>
        </div>
    ) : null;
};

export default TIdLinkField;
